export class Cantidad {
    public Value: number;

    constructor(cantidad:number){
        this.Value = cantidad;
    }
}
